import React from "react";
import "./tkhlesmoa.css";
import { Container } from "react-bootstrap";
import {  useNavigate } from "react-router-dom";
import notify from "../../../../Notifcation";
const Takhlesmethod = ({ userData }) => {
  const navegate = useNavigate();
  const checkUserElectric = () => {
    if (userData && userData.user_type === "client") {
      navegate("/user/electric");
    } else {
      notify("من فضلك قم بتسجيل الدخول اولاً  ", "error");
      setTimeout(() => {
        navegate("/login");
      }, 3000);
    }
  };
  const checkUserGas = () => {
    if (userData && userData.user_type === "client") {
      navegate("/user/gas");
    } else {
      notify("من فضلك قم بتسجيل الدخول اولاً  ", "error");
      setTimeout(() => {
        navegate("/login");
      }, 3000);
    }
  };
  return (
    <Container>
      <div className="paymentmethod">
        <div className="naqdi">
          {" "}
          <button onClick={checkUserElectric} className="mainb">
            خدمات الكهرباء  <i className="fa-solid fa-bolt-lightning"></i>
          </button>
        </div>
        <div className="banqi">
          {" "}
          <button onClick={checkUserGas} className="mainb">
            خدمات الغاز  <i className="fa-solid fa-file-lines"></i>
          </button>
        </div>
      </div>
    </Container>
  );
};

export default Takhlesmethod;
